import { useParams } from 'react-router-dom';

import { AsPlainObject } from '@app/utils/type.utils';

import { TExtractParams } from '../types';

export const useTypedParams = <TPath extends string>(_route: TPath) =>
  useParams<AsPlainObject<TExtractParams<TPath>>>();
